<template>
  <ContactsTab />
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapState, mapGetters } from 'vuex'
// Components
import ContactsTab from '@/reusable/contacts-tab/ContactsTab'

export default {
  components: {
    ContactsTab
  },

  props: {
    id: [Number, String] // from route
  },

  provide() {
    return {
      provider: this.publisher,
      mainAddress: this.mainAddress
    }
  },

  computed: {
    ...mapState('publisher-show', ['publisher']),
    ...mapGetters('publisher-show', ['mainAddress'])
  }
}
</script>
